<template>
  <v-container>
    <app-navigation></app-navigation>
    <v-main class="pt-12">
      <div class="pt-md-5">
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <main-sub-page-toolbar icon="mdi-account-star">
              {{ $t("dashboardCardAddClientSuperAdminTitle") }}
            </main-sub-page-toolbar>
          </v-flex>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <div>
              <data-table-search-toolbar
                :search.sync="search"
              ></data-table-search-toolbar>
              <v-data-table
                :loading-text="$t('lmPleaseWait')"
                class="#505050--text"
                :class="
                  getTheme() == 'dark'
                    ? 'outlined elevation-0'
                    : 'flat elevation-0'
                "
                :style="
                  getTheme() == 'dark'
                    ? 'border: 1px solid darkgray; border-top: none; background-color: white'
                    : 'border: none; background-color: white'
                "
                :headers="headers"
                :items="$store.state.storeClient.clients"
                :search="search"
                sort-by="basicSettings.name"
                :items-per-page="-1"
                must-sort
                show-expand
                :no-results-text="$t('dataGridSlotNoResults')"
                :no-data-text="$t('dataGridSlotNoData')"
                :footer-props="{
                  itemsPerPageText: $t('dataGridRowsPerPageText'),
                  itemsPerPageAllText: $t('dataGridRowsPerPageAllText'),
                }"
              >
                <template v-slot:expanded-item="{ item }">
                  <td :colspan="headers.length" class="py-2">
                    <div class="py-1 overline">
                      {{ $t("settingsOtherBasePriceTitle") }}
                    </div>
                    <div class="py-1">
                      {{ price(item.pricing.basePrice) }}
                    </div>
                    <div class="py-1 overline">
                      {{ $t("settingsOtherBaseLimitTitle") }}
                    </div>
                    <div class="py-1">
                      {{ price(item.pricing.baseLimit) }}
                    </div>
                    <div class="py-1 overline">
                      {{ $t("settingsOtherOverLimitPctTitle") }}
                    </div>
                    <div class="py-1">
                      {{ item.pricing.overLimitPct }}
                    </div>
                  </td>
                </template>
                <template v-slot:item.active="{ item }">
                  <v-icon
                    @click="
                      toggleClientBoolean(item, 'toggleClientBooleanActive')
                    "
                    :color="item.active ? 'success' : 'error'"
                    >{{
                      item.active
                        ? "mdi-check-circle-outline"
                        : "mdi-close-circle-outline"
                    }}</v-icon
                  >
                </template>
                <template v-slot:item.visible="{ item }">
                  <v-icon
                    @click="
                      toggleClientBoolean(item, 'toggleClientBooleanVisible')
                    "
                    :color="item.visible ? 'success' : 'error'"
                    >{{
                      item.visible
                        ? "mdi-check-circle-outline"
                        : "mdi-close-circle-outline"
                    }}</v-icon
                  >
                </template>
                <template v-slot:item.modules.moduleModerator.active="{ item }">
                  <v-icon
                    @click="
                      toggleClientBoolean(
                        item,
                        'toggleClientBooleanModeratorActive'
                      )
                    "
                    :color="
                      item.modules.moduleModerator.active ? 'success' : 'error'
                    "
                    >{{
                      item.modules.moduleModerator.active
                        ? "mdi-check-circle-outline"
                        : "mdi-close-circle-outline"
                    }}</v-icon
                  >
                </template>
                <template
                  v-slot:item.modules.modulePhotoOrder.active="{ item }"
                >
                  <v-icon
                    @click="
                      toggleClientBoolean(
                        item,
                        'toggleClientBooleanPhotoOrderActive'
                      )
                    "
                    :color="
                      item.modules.modulePhotoOrder.active ? 'success' : 'error'
                    "
                    >{{
                      item.modules.modulePhotoOrder.active
                        ? "mdi-check-circle-outline"
                        : "mdi-close-circle-outline"
                    }}</v-icon
                  >
                </template>
                <template v-slot:item.modules.modulePhotoGift.active="{ item }">
                  <v-icon
                    @click="
                      toggleClientBoolean(
                        item,
                        'toggleClientBooleanPhotoGiftActive'
                      )
                    "
                    :color="
                      item.modules.modulePhotoGift.active ? 'success' : 'error'
                    "
                    >{{
                      item.modules.modulePhotoGift.active
                        ? "mdi-check-circle-outline"
                        : "mdi-close-circle-outline"
                    }}</v-icon
                  >
                </template>
                <template v-slot:item.modules.moduleGiftCard.active="{ item }">
                  <v-icon
                    @click="
                      toggleClientBoolean(
                        item,
                        'toggleClientBooleanGiftCardActive'
                      )
                    "
                    :color="
                      item.modules.moduleGiftCard.active ? 'success' : 'error'
                    "
                    >{{
                      item.modules.moduleGiftCard.active
                        ? "mdi-check-circle-outline"
                        : "mdi-close-circle-outline"
                    }}</v-icon
                  >
                </template>
                <template
                  v-slot:item.modules.moduleUserSettings.active="{ item }"
                >
                  <v-icon
                    @click="
                      toggleClientBoolean(
                        item,
                        'toggleClientBooleanUserSettingsActive'
                      )
                    "
                    :color="
                      item.modules.moduleUserSettings.active
                        ? 'success'
                        : 'error'
                    "
                    >{{
                      item.modules.moduleUserSettings.active
                        ? "mdi-check-circle-outline"
                        : "mdi-close-circle-outline"
                    }}</v-icon
                  >
                </template>
                <template v-slot:item.pricing.active="{ item }">
                  <v-icon
                    @click="
                      toggleClientBoolean(
                        item,
                        'toggleClientBooleanPricingActive'
                      )
                    "
                    :color="item.pricing.active ? 'success' : 'error'"
                    >{{
                      item.pricing.active
                        ? "mdi-check-circle-outline"
                        : "mdi-close-circle-outline"
                    }}</v-icon
                  >
                </template>
                <template v-slot:item.subCalc="{ item }">
                  <span
                    v-if="
                      item.monthStats.totalSumCart <= item.pricing.baseLimit
                    "
                    >{{ price(item.pricing.basePrice) }}</span
                  >
                  <span
                    v-else-if="
                      item.monthStats.totalSumCart > item.pricing.baseLimit
                    "
                    >{{
                      price(
                        item.pricing.basePrice +
                          (item.monthStats.totalSumCart -
                            item.pricing.baseLimit) *
                            (item.pricing.overLimitPct / 100)
                      )
                    }}</span
                  >
                </template>
                <template v-slot:item.dayStats.totalSumCart="{ item }">{{
                  item.dayStats.totalSumCart !== undefined
                    ? price(item.dayStats.totalSumCart)
                    : 0
                }}</template>
                <template v-slot:item.monthStats.totalSumCart="{ item }">{{
                  item.monthStats.totalSumCart !== undefined
                    ? price(item.monthStats.totalSumCart)
                    : 0
                }}</template>
                <template v-slot:item.yearStats.totalSumCart="{ item }">{{
                  item.yearStats.totalSumCart !== undefined
                    ? price(item.yearStats.totalSumCart)
                    : 0
                }}</template>
                <template v-slot:item.actions="{ item }">
                  <div class="d-flex flex-no-wrap">
                    <v-icon class="mr-3" @click="editItem(item)"
                      >mdi-pencil</v-icon
                    >
                    <v-icon @click="deleteItemSet(item.id)">mdi-delete</v-icon>
                  </div>
                </template>
              </v-data-table>
            </div>
            <!-- DELETE CONFIRM DIALOG -->
            <dialog-basic-yes-no
              :active="dialogDelete"
              @clickYes="deleteItem"
              @clickNo="dialogDelete = false"
              icon="mdi-comment-question-outline"
              :title="$t('msgQuestion')"
              >{{ $t("deleteDialogQuestion") }}</dialog-basic-yes-no
            >
          </v-flex>
          <simple-navigation-button
            left
            :title="$t('lmBtnBack')"
            icon="mdi-arrow-left"
            @clicked="$router.push({ name: 'home' })"
          ></simple-navigation-button>

          <!-- ADD / EDIT DIALOG -->
          <v-dialog
            v-model="dialog"
            max-width="500px"
            persistent
            transition="dialog-bottom-transition"
          >
            <template v-slot:activator="{ on }">
              <v-btn color="primary" v-on="on" dark fixed bottom right rounded>
                <v-icon medium class="mr-1">mdi-plus</v-icon>
                {{ $t("lmBtnAdd") }}
              </v-btn>
            </template>
            <v-form ref="form" v-model="valid">
              <v-card
                :class="
                  getTheme() == 'dark'
                    ? 'outlined elevation-0'
                    : 'flat elevation-0'
                "
                :style="
                  getTheme() == 'dark'
                    ? ''
                    : 'border-bottom: 1px solid lightgray'
                "
              >
                <v-card-title
                  :style="
                    getTheme() == 'dark'
                      ? 'background-color: #505050'
                      : 'background-color: white; border-bottom: 1px solid lightgray'
                  "
                  :class="
                    getTheme() == 'dark' ? 'white--text' : '#505050--text'
                  "
                  class="title font-weight-regular"
                >
                  <v-icon
                    :class="
                      getTheme() == 'dark' ? 'white--text' : 'primary--text'
                    "
                    class="mr-3"
                    medium
                    >{{
                      this.editedIndex == -1 ? "mdi-plus" : "mdi-pencil"
                    }}</v-icon
                  >
                  {{ formTitle }}
                </v-card-title>
                <v-card-text class="py-0 pt-2">
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-text-field
                          class="mb-3"
                          v-model="editedItem.basicSettings.fullName"
                          :label="$t('settingsOtherFullNameTitle')"
                          :rules="[validateRequired(), validateMaxLength(50)]"
                          :counter="50"
                          dense
                        ></v-text-field>
                        <v-text-field
                          class="mb-3"
                          v-model="editedItem.basicSettings.name"
                          :label="$t('settingsOtherClientTitle')"
                          :rules="[validateRequired(), validateMaxLength(50)]"
                          :counter="50"
                          dense
                        ></v-text-field>
                        <v-switch
                          dense
                          style="height: 30px"
                          class="ma-0 pa-0"
                          v-model="editedItem.active"
                          :label="$t('settingsOtherActiveTitle')"
                        ></v-switch>
                        <v-switch
                          dense
                          style="height: 30px"
                          class="ma-0 pa-0"
                          v-model="editedItem.visible"
                          :label="$t('settingsOtherVisibleTitle')"
                        ></v-switch>
                        <v-switch
                          dense
                          style="height: 30px"
                          class="ma-0 pa-0"
                          v-model="editedItem.modules.moduleModerator.active"
                          :label="$t('settingsUserRightsisModerator')"
                        ></v-switch>
                        <v-switch
                          dense
                          style="height: 30px"
                          class="ma-0 pa-0"
                          v-model="editedItem.modules.modulePhotoOrder.active"
                          :label="
                            $t('dashboardCardModulePhotoOrderUserSubTitle')
                          "
                        ></v-switch>
                        <v-switch
                          dense
                          style="height: 30px"
                          class="ma-0 pa-0"
                          v-model="editedItem.modules.modulePhotoGift.active"
                          :label="$t('dashboardCardModulePhotoGiftSubTitle')"
                        ></v-switch>
                        <v-switch
                          dense
                          style="height: 30px"
                          class="ma-0 pa-0"
                          v-model="editedItem.modules.moduleGiftCard.active"
                          :label="$t('settingsSubMenuModuleGiftCardTitle')"
                        ></v-switch>
                        <v-switch
                          dense
                          style="height: 30px"
                          class="ma-0 pa-0"
                          v-model="editedItem.modules.moduleUserSettings.active"
                          :label="$t('dashboardCardUserSettingsTitle')"
                        ></v-switch>
                        <v-switch
                          dense
                          style="height: 30px"
                          class="ma-0 pa-0 mb-6"
                          v-model="editedItem.pricing.active"
                          :label="$t('settingsOtherPricingTitle')"
                        ></v-switch>
                        <v-text-field
                          v-model="
                            editedItem.environmentSettings.autoResponseEmail
                          "
                          :label="$t('settingsOtherAutoResponseEmail')"
                          :rules="[validateRequired()]"
                          :counter="250"
                          dense
                        ></v-text-field>
                        <v-text-field
                          v-model="editedItem.pricing.basePrice"
                          :label="$t('settingsOtherBasePriceTitle')"
                          :rules="[validateRequired(), validateIsCurrency()]"
                          :counter="20"
                          dense
                        ></v-text-field>
                        <v-text-field
                          v-model="editedItem.pricing.baseLimit"
                          :label="$t('settingsOtherBaseLimitTitle')"
                          :rules="[validateRequired(), validateIsCurrency()]"
                          :counter="20"
                          dense
                        ></v-text-field>
                        <v-text-field
                          v-model="editedItem.pricing.overLimitPct"
                          :label="$t('settingsOtherOverLimitPctTitle')"
                          :rules="[validateRequired(), validateIsPercent()]"
                          :counter="3"
                          dense
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions
                  :class="
                    getTheme() == 'dark' ? '#505050--text' : '#505050--text'
                  "
                  :style="
                    getTheme() == 'dark'
                      ? 'background-color: whitesmoke; border-top: 1px solid lightgray;'
                      : 'background-color: white; border-top: 1px solid lightgray;'
                  "
                >
                  <v-spacer></v-spacer>
                  <v-btn color="primary" class="my-1" text @click="close">{{
                    $t("addEditFormCancelButton")
                  }}</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn @click="save" color="primary" dark>
                    <v-icon medium class="mr-1">mdi-content-save</v-icon>
                    {{ $t("addEditFormSaveButton") }}
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-dialog>
          <v-snackbar
            v-model="$store.state.storeSnackbar.snackbar.active"
            :color="$store.state.storeSnackbar.snackbar.color"
            :timeout="$store.state.storeSnackbar.snackbar.timeout"
            >{{ $store.state.storeSnackbar.snackbar.message }}</v-snackbar
          >
        </v-layout>
      </div>
    </v-main>
  </v-container>
</template>

<script>
import AppNavigation from "@/views/AppNavigation";
import MainSubPageToolbar from "@/components/MainSubPageToolbar";
import DialogBasicYesNo from "@/components/DialogBasicYesNo";
import SimpleNavigationButton from "@/components/SimpleNavigationButton";
import DataTableSearchToolbar from "@/components/DataTableSearchToolbar";

export default {
  name: "settingsClient",
  components: {
    AppNavigation,
    MainSubPageToolbar,
    DialogBasicYesNo,
    SimpleNavigationButton,
    DataTableSearchToolbar,
  },
  data() {
    return {
      valid: true,
      netBackImage: require("@/assets/netBack.png"),
      search: "",
      dialog: false,
      dialogDelete: false,
      dialogDeleteId: "",
      headers: [
        {
          text: this.$t("settingsOtherFullNameTitle"),
          align: "left",
          value: "basicSettings.fullName",
          sortable: true,
        },
        {
          text: this.$t("settingsOtherClientTitle"),
          align: "center",
          value: "basicSettings.name",
          sortable: true,
        },
        {
          text: this.$t("settingsOtherActiveTitle"),
          align: "center",
          value: "active",
        },
        {
          text: this.$t("settingsOtherVisibleTitle"),
          align: "center",
          value: "visible",
        },
        {
          text: this.$t("settingsUserRightsisModerator"),
          align: "center",
          value: "modules.moduleModerator.active",
        },
        {
          text: this.$t("dashboardCardModulePhotoOrderUserSubTitle"),
          align: "center",
          value: "modules.modulePhotoOrder.active",
        },
        {
          text: this.$t("dashboardCardModulePhotoGiftSubTitle"),
          align: "center",
          value: "modules.modulePhotoGift.active",
        },
        {
          text: this.$t("settingsSubMenuModuleGiftCardTitle"),
          align: "center",
          value: "modules.moduleGiftCard.active",
        },
        {
          text: this.$t("settingsOtherPricingTitle"),
          align: "center",
          value: "pricing.active",
        },
        {
          text: this.$t("settingsOtherSubCalcTitle"),
          align: "center",
          sortable: false,
          value: "subCalc",
        },
        {
          text: this.$t("settingsOtherTodayTitle"),
          align: "center",
          value: "dayStats.totalSumCart",
          sortable: true,
        },
        {
          text: this.$t("settingsOtherThisMonthTitle"),
          align: "center",
          value: "monthStats.totalSumCart",
          sortable: true,
        },
        {
          text: this.$t("settingsOtherThisYearTitle"),
          align: "center",
          value: "yearStats.totalSumCart",
          sortable: true,
        },
        {
          text: "",
          align: "center",
          sortable: false,
          value: "actions",
        },
        {
          text: this.$t("msgMore"),
          value: "data-table-expand",
        },
      ],
      editedIndex: -1,
      editedItem: {
        active: true,
        visible: true,
        basicSettings: {
          companyInfo: "",
          fullName: "",
          name: "",
        },
        environmentSettings: {
          currency: "EUR",
          numberFormat: "sl",
          digits: 2,
          lang: "sl",
          dateFormat: "DD.MM.YYYY",
          taxTitle: "",
          autoResponseEmail: "",
        },
        prepaySettings: {
          prepayInfo: "",
          enableQRCode: false,
          qrCompanyAccount: "",
          qrCompanyAddress1: "",
          qrCompanyAddress2: "",
          qrCompanyTitle: "",
          qrCodeFormat: "sl",
        },
        responseSettings: {
          cartItemExpire: this.$t("settingsOtherCartExpireResponse"),
          newOrderMsg: this.$t("userCashierEmailNewOrderStart"),
          newOrderPrepayMsg: this.$t("userCashierEmailNewOrderPrepayStart"),
          orderCompletedPersonal: this.$t(
            "userCashierEmailOrderCompletedPersonalDelivery"
          ),
          orderCompletedPost: this.$t(
            "userCashierEmailOrderCompletedPostDelivery"
          ),
        },
        loginSettings: {
          background: {
            color: "#E8E8E8",
            image: false,
            imageKeyword: "",
            shadowStrength: 66,
            shadowType: 0,
          },
          clientPunchline: "",
          image: false,
          imageKeyword: "",
          imageStorageLink: "",
          logoLink: "",
          showActivePromoCodes: true,
          welcomeMessage: "",
        },
        orderPrintSettings: {
          font: "TimesNewRoman",
          size: 12,
          width: 800,
        },
        modules: {
          moduleModerator: {
            active: true,
            show: false,
          },
          modulePhotoGift: {
            active: true,
            notifyEmail: "",
            show: false,
            taxPct: "",
            extraCharge: "0",
            extraChargeMessage: "",
            extraChargeFreeOver: "0",
          },
          moduleGiftCard: {
            active: true,
            notifyEmail: "",
            show: false,
            taxPct: "",
            menuImage: "",
            subtitle: "",
            title: "",
            whiteText: false,
          },
          modulePhotoOrder: {
            active: true,
            menuImage: "",
            subtitle: "",
            title: "",
            whiteText: false,
            notifyEmail: "",
            show: false,
            taxPct: "",
            extraCharge: "0",
            extraChargeMessage: "",
            extraChargeFreeOver: "0",
            minOrder: "0",
            enableSimpleUpload: true,
            enableAdvancedUpload: true,
            keepOriginalFileNames: false,
            enableDate: true,
            enableCrop: true,
          },
          moduleUserSettings: {
            active: true,
            menuImage: "",
            subtitle: "",
            title: "",
            whiteText: false,
            show: true,
          },
        },
        visualSettings: {
          themeColor: {
            accentColor: "#E27070",
            primaryColor: "#25832C",
            secondaryColor: "#582FA3",
            type: "dark",
          },
        },
        pricing: {
          active: true,
          basePrice: 30,
          baseLimit: 300,
          overLimitPct: 5,
        },
        rulesAndSecurityInfo: {
          privacyHTML: "",
          rulesHTML: "",
          cookiesHTML: "",
          showCookiesInfo: true,
          showPrivacyInfo: false,
          showRulesInfo: false,
        },
      },
      defaultItem: {
        active: true,
        visible: true,
        basicSettings: {
          companyInfo: "",
          fullName: "",
          name: "",
        },
        environmentSettings: {
          currency: "EUR",
          numberFormat: "sl",
          digits: 2,
          lang: "sl",
          dateFormat: "DD.MM.YYYY",
          taxTitle: "",
          autoResponseEmail: "",
        },
        prepaySettings: {
          prepayInfo: "",
          enableQRCode: false,
          qrCompanyAccount: "",
          qrCompanyAddress1: "",
          qrCompanyAddress2: "",
          qrCompanyTitle: "",
          qrCodeFormat: "sl",
        },
        responseSettings: {
          cartItemExpire: this.$t("settingsOtherCartExpireResponse"),
          newOrderMsg: this.$t("userCashierEmailNewOrderStart"),
          newOrderPrepayMsg: this.$t("userCashierEmailNewOrderPrepayStart"),
          orderCompletedPersonal: this.$t(
            "userCashierEmailOrderCompletedPersonalDelivery"
          ),
          orderCompletedPost: this.$t(
            "userCashierEmailOrderCompletedPostDelivery"
          ),
        },
        loginSettings: {
          background: {
            color: "#E8E8E8",
            image: false,
            imageKeyword: "",
            shadowStrength: 66,
            shadowType: 0,
          },
          clientPunchline: "",
          image: false,
          imageKeyword: "",
          imageStorageLink: "",
          logoLink: "",
          showActivePromoCodes: true,
          welcomeMessage: "",
        },
        orderPrintSettings: {
          font: "TimesNewRoman",
          size: 12,
          width: 800,
        },
        modules: {
          moduleModerator: {
            active: true,
            show: false,
          },
          modulePhotoGift: {
            active: true,
            notifyEmail: "",
            show: false,
            taxPct: "",
            extraCharge: "0",
            extraChargeMessage: "",
            extraChargeFreeOver: "0",
          },
          moduleGiftCard: {
            active: true,
            notifyEmail: "",
            show: false,
            taxPct: "",
            menuImage: "",
            subtitle: "",
            title: "",
            whiteText: false,
          },
          modulePhotoOrder: {
            active: true,
            menuImage: "",
            subtitle: "",
            title: "",
            whiteText: false,
            notifyEmail: "",
            show: false,
            taxPct: "",
            extraCharge: "0",
            extraChargeMessage: "",
            extraChargeFreeOver: "0",
            minOrder: "0",
            enableSimpleUpload: true,
            enableAdvancedUpload: true,
            keepOriginalFileNames: false,
            enableDate: true,
            enableCrop: true,
          },
          moduleUserSettings: {
            active: true,
            menuImage: "",
            subtitle: "",
            title: "",
            whiteText: false,
            show: true,
          },
        },
        visualSettings: {
          themeColor: {
            accentColor: "#E27070",
            primaryColor: "#25832C",
            secondaryColor: "#582FA3",
            type: "dark",
          },
        },
        pricing: {
          active: true,
          basePrice: 30,
          baseLimit: 300,
          overLimitPct: 5,
        },
        rulesAndSecurityInfo: {
          privacyHTML: "",
          rulesHTML: "",
          cookiesHTML: "",
          showCookiesInfo: true,
          showPrivacyInfo: false,
          showRulesInfo: false,
        },
      },
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("addEditFormAddingTitle")
        : this.$t("addEditFormEditingTitle");
    },
  },
  methods: {
    async toggleClientBoolean(item, field) {
      try {
        await this.$store.dispatch(field, item);
      } catch (error) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error,
        });
        return;
      }
    },
    deleteItemSet(item) {
      this.dialogDelete = true;
      this.dialogDeleteId = item;
    },
    async deleteItem() {
      try {
        await this.$store.dispatch("removeClient", this.dialogDeleteId);
        this.dialogDelete = false;
        this.dialogDeleteId = "";
      } catch (error) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error,
        });
        return;
      }
      this.$store.commit({
        type: "showSnackbar",
        color: "success",
        message: this.$t("msgSuccessDelete"),
      });
    },
    editItem(item) {
      this.editedIndex = this.$store.state.storeClient.clients.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    },
    async save() {
      if (this.$refs.form.validate()) {
        if (this.editedIndex > -1) {
          try {
            await this.$store.dispatch("editClient", this.editedItem);
            this.$store.commit({
              type: "showSnackbar",
              color: "success",
              message: this.$t("msgSuccessEdit"),
            });
          } catch (error) {
            this.$store.commit({
              type: "showSnackbar",
              color: "error",
              message: error,
            });
          }
        } else {
          try {
            await this.$store.dispatch("addClient", this.editedItem);
            this.$store.commit({
              type: "showSnackbar",
              color: "success",
              message: this.$t("msgSuccessAdd"),
            });
          } catch (error) {
            this.$store.commit({
              type: "showSnackbar",
              color: "error",
              message: error,
            });
          }
        }
        this.close();
      }
    },
  },
};
</script>
